import useApp from "hooks/useApp"
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { setMessageInput } from "store/app/app.actions";

type IReturns = [string, (txt: string) => void]

const useMessageInput = () => {
    const dispatch = useDispatch();
    const { messageInput } = useApp();

    const _setMessageInput = useCallback((txt: string) => {
        dispatch(setMessageInput(txt))
    }, [dispatch])

    return [messageInput, _setMessageInput] as IReturns
}

export default useMessageInput;